function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M179.664 175.387V103.853",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M161.695 81.3673L21.931 81.2473C18.103 81.2473 15.001 83.6933 15.001 86.7113V175.387C15.001 178.405 18.103 180.849 21.931 180.849H164.367",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.152 169.105H34.9023C30.9923 169.105 27.8203 165.935 27.8203 162.023V156.565C27.8203 152.653 30.9923 149.483 34.9023 149.483H159.152C163.064 149.483 166.234 152.653 166.234 156.565V162.023C166.234 165.935 163.064 169.105 159.152 169.105Z",
  fill: "#BACEFD"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M158.819 139.441H34.5693C30.6573 139.441 27.4873 136.271 27.4873 132.361V126.901C27.4873 122.991 30.6573 119.819 34.5693 119.819H158.819C162.731 119.819 165.901 122.991 165.901 126.901V132.361C165.901 136.271 162.731 139.441 158.819 139.441Z",
  fill: "#82A7FC"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.1727 40.7538C61.3587 39.5678 62.5987 38.4398 63.8887 37.3698C67.8727 34.0678 72.3387 31.3318 77.1707 29.2838C83.5947 26.5578 90.6607 25.0518 98.0787 25.0518C127.685 25.0518 151.687 49.0518 151.687 78.6598C151.687 108.266 127.685 132.268 98.0787 132.268C68.4727 132.268 44.4707 108.266 44.4707 78.6598C44.4707 71.5638 45.8507 64.7938 48.3527 58.5958",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M60.1727 40.7538C61.3587 39.5678 62.5987 38.4398 63.8887 37.3698C67.8727 34.0678 72.3387 31.3318 77.1707 29.2838C83.5947 26.5578 90.6607 25.0518 98.0787 25.0518C127.685 25.0518 151.687 49.0518 151.687 78.6598C151.687 108.266 127.685 132.268 98.0787 132.268C68.4727 132.268 44.4707 108.266 44.4707 78.6598C44.4707 71.5638 45.8507 64.7938 48.3527 58.5958",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.139 121.055C89.4409 122.263 76.3409 117.773 66.9589 107.731C58.9309 99.1387 55.1469 88.1027 55.5169 77.2127C55.6089 74.4967 55.9609 71.7867 56.5689 69.1267",
  fill: "white"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M102.139 121.055C89.4409 122.263 76.3409 117.773 66.9589 107.731C58.9309 99.1387 55.1469 88.1027 55.5169 77.2127C55.6089 74.4967 55.9609 71.7867 56.5689 69.1267",
  stroke: "#126DFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.0078 47.541C86.1938 31.485 113.142 32.403 129.198 49.587C135.218 56.033 138.854 63.851 140.138 71.953C142.278 85.455 137.892 99.745 127.15 109.779",
  fill: "white"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M69.0078 47.541C86.1938 31.485 113.142 32.403 129.198 49.587C135.218 56.033 138.854 63.851 140.138 71.953C142.278 85.455 137.892 99.745 127.15 109.779",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.5134 93.164L116.773 62.904C118.063 61.616 120.153 61.616 121.443 62.904L121.843 63.302C123.131 64.592 123.131 66.684 121.843 67.972L91.5814 98.232C90.2914 99.522 88.2014 99.522 86.9114 98.232L86.5134 97.834C85.2234 96.544 85.2234 94.456 86.5134 93.164Z",
  fill: "#34C724"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.6561 78.8535L91.6741 92.8695C93.0721 94.2695 93.0721 96.5395 91.6741 97.9375C90.2741 99.3375 88.0041 99.3375 86.6061 97.9375L72.5881 83.9195C71.1881 82.5215 71.1881 80.2515 72.5881 78.8535C73.9881 77.4535 76.2561 77.4535 77.6561 78.8535Z",
  fill: "#34C724"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.6787 47.2871L37.5867 50.1851L32.6787 47.2871Z",
  fill: "white"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M32.6787 47.2871L37.5867 50.1851",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.999 36.4727L41.091 41.0547L35.999 36.4727Z",
  fill: "white"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M35.999 36.4727L41.091 41.0547",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M169.328 54L156.532 59.842L169.328 54Z",
  fill: "white"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M169.328 54L156.532 59.842",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M165.814 64.1523L158.222 65.8223L165.814 64.1523Z",
  fill: "white"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M165.814 64.1523L158.222 65.8223",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.275 47.3164L155.027 51.7704L159.275 47.3164Z",
  fill: "white"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M159.275 47.3164L155.027 51.7704",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M126.009 159.086H150.891",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M41.4043 159.086H110.172",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref26 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 167,
  y: 73,
  width: 20,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M167.972 73.3977H186.51V96.6048H167.972V73.3977Z",
  fill: "white"
}));
var _ref27 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M176.991 96.1837L174.133 85.4077L168.443 83.7617C167.835 83.1817 167.813 82.2097 168.393 81.6017L174.387 80.0597L175.779 73.8697C176.359 73.2617 177.331 73.2377 177.939 73.8177L180.497 79.9337L186.039 81.5577C186.649 82.1377 186.669 83.1097 186.089 83.7177L180.115 85.5357L179.151 96.1357C178.571 96.7417 177.599 96.7637 176.991 96.1837Z",
  fill: "#FFC60A"
}));
var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.1096 74.5351L31.7596 69.1371L28.5156 68.1991C28.1676 67.8671 28.1556 67.3131 28.4856 66.9671L31.9056 66.0871L32.6996 62.5571C33.0296 62.2091 33.5856 62.1971 33.9316 62.5271L35.3916 66.0151L38.5536 66.9411C38.8996 67.2711 38.9116 67.8271 38.5816 68.1731L35.1736 69.2111L34.3416 74.5051C34.0116 74.8531 33.4556 74.8651 33.1096 74.5351Z",
  fill: "#FFC60A"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.8128 65.5567L50.7428 53.2767L43.3588 51.1407C42.5708 50.3887 42.5408 49.1267 43.2948 48.3387L51.0728 46.3387L52.8808 38.3027C53.6328 37.5147 54.8948 37.4847 55.6828 38.2387L59.0028 46.1747L66.1968 48.2787C66.9848 49.0327 67.0148 50.2927 66.2608 51.0827L58.5088 53.4407L56.6148 65.4927C55.8628 66.2807 54.6008 66.3107 53.8128 65.5567Z",
  fill: "#FFC60A"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.9424 23L59.2344 29.492L56.9424 23Z",
  fill: "white"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M56.9424 23L59.2344 29.492",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var SvgMobileQuestionnaireSuccess = function SvgMobileQuestionnaireSuccess(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileQuestionnaireSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile_questionnaire_success.4492f221.svg";
export { ForwardRef as ReactComponent };